import React, { useEffect, useMemo,useRef,useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/posts/postsActions";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../../../../_metronic/_helpers";
import * as uiHelpers from "../CustomersUIHelpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { usePostsUIContext } from "../PostsUIContext";
import { CSVLink } from 'react-csv';

export function PostsTable() {
  // Customers UI Context
  const postsUIContext = usePostsUIContext();
  const customersUIProps = useMemo(() => {
    return {
      ids: postsUIContext.ids,
      setIds: postsUIContext.setIds,
      queryParams: postsUIContext.queryParams,
      setQueryParams: postsUIContext.setQueryParams,
      openEditPostDialog: postsUIContext.openEditPostDialog,
      openDeletePostDialog: postsUIContext.openDeletePostDialog,
    };
  }, [postsUIContext]);

  // Getting curret state of customers list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.customers }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  const csvLink = useRef()
  const [transactionData, setTransactionData] =   useState([])
  // Customers Redux state
  const dispatch = useDispatch();
  useEffect(() => {
    // clear selections list
    customersUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchCustomers(customersUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customersUIProps.queryParams, dispatch]);
  // Table columns
  const columns = [
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    // },
    {
      dataField: "userName",
      text: "User Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: {
        minWidth: "100px",
      },
    },
    {
      dataField: "area",
      text: "area",
      sort: true,
      style: {
        minWidth: "100px",
      },
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
      style: {
        maxWidth: "300px",
      },
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    // {
    //   dataField: "gender",
    //   text: "Gender",
    //   sort: false,
    //   sortCaret: sortCaret,
    // },
    {
      dataField: "category",
      text: "Category",
      sort: true,
      sortCaret: sortCaret,
      //formatter: columnFormatters.StatusColumnFormatter,
      headerSortingClasses,
    },
    {
      dataField: "resharing",
      text: "Resharing",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell,row) => {
        return cell ? 'yes' :'no';
      },
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.StatusColumnFormatter,
      style: {
        minWidth: "100px",
      },
      headerSortingClasses,
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditPostDialog: customersUIProps.openEditPostDialog,
        openDeletePostDialog: customersUIProps.openDeletePostDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];
     const getTransactionData = async () => {
   setTransactionData(entities === null ? [] : entities)
    csvLink.current.link.click()
  }
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: customersUIProps.queryParams.pageSize,
    page: customersUIProps.queryParams.pageNumber,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
               <button onClick={getTransactionData}>Download posts to csv</button>
              <CSVLink
                  data={entities === null ? [] : entities}
                  filename='posts.csv'
                  className='hidden'
                  ref={csvLink}
                  target='_blank'
                />
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  customersUIProps.setQueryParams
                )}
                selectRow={getSelectRow({
                  entities,
                  ids: customersUIProps.ids,
                  setIds: customersUIProps.setIds,
                })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
